export default "__VITE_ASSET__jUBqETrp__"